import React from "react";
import styled from "styled-components";
import Link from "gatsby-link";
import Img from "gatsby-image";

const DonateRow = ({ image }) => (
	<DonateRowContainer>
		<div>
			<DonateRowTitle>Donate</DonateRowTitle>
			<DonateRowSubtitle>Help Us Help Others</DonateRowSubtitle>
			<DonateRowTagline>Helping, healing and supporting women in crisis takes many hands. Donate today and bring hope.</DonateRowTagline>
			<DonateButton to="/donate">Donate</DonateButton>
		</div>
		<DonateFlower sizes={image.childImageSharp.sizes} />
	</DonateRowContainer>
);

const DonateRowContainer = styled.div`
	padding: ${(100 / 24) * 1.5}vw ${(100 / 24) * 3}vw;
	display: flex;
	overflow: hidden;
	height: ${(100 / 24) * 6.5}vw;
	min-height: 350px;
	box-sizing: border-box;

	@media screen and (max-width: 768px) {
		position: relative;
		.gatsby-image-outer-wrapper {
			position: absolute !important;
			right: 0;
			bottom: 0;
			overflow-x: hidden;
		}
	}

	@media screen and (max-width: 600px) {
		height: auto;
		.gatsby-image-outer-wrapper {
			transform: rotate(90deg);
		}
	}
`;

const DonateFlower = styled(Img)`
	width: ${(100 / 24) * 11}vw;
	transform: translateY(-15%) translateX(20%);

	@media screen and (max-width: 768px) {
		transform: translateY(15%) translateX(30%);
	}

	@media screen and (max-width: 600px) {
		transform: translateY(15%) translateX(40%);
	}
`;

const DonateRowTitle = styled.h1`
	color: #0e4749;
	margin: 0;
	font-weight: bold;
	font-size: 4rem;
`;

const DonateRowSubtitle = styled.span`
	color: #05a143;
	text-transform: uppercase;
	font-weight: bold;
	line-height: 1.5;
	letter-spacing: 0.25rem;
`;

const DonateRowTagline = styled.h4`
	color: #728c8f;
	width: ${(100 / 24) * 8}vw;
	font-weight: normal;
	margin: 1rem 0;
	margin-bottom: 3rem;
	line-height: 1.333;

	@media screen and (max-width: 768px) {
		width: 75%;
	}

	@media screen and (max-width: 600px) {
		width: 100%;
	}
`;

export const DonateButton = styled(Link)`
	color: white;
	background: linear-gradient(45deg, #136163, #05a143);
	padding: 1rem 4rem;
	border-radius: 10px;
	font-size: 1.333rem;
	text-transform: uppercase;
	font-weight: bold;
	box-shadow: 0 5px 10px rgba(4, 135, 56, 0.3);
	transition: 300ms;

	&:hover {
		box-shadow: 0 10px 20px rgba(4, 135, 56, 0.3);
		transform: translateY(-0.5rem);
	}

	@media screen and (max-width: 1024px) {
		padding: 0.75rem 2rem;
		font-size: 1rem;
	}
`;

export default DonateRow;



// WEBPACK FOOTER //
// ./src/components/DonateRow.jsx